"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The ExpressionOfInterestFilter model module.
 * @module model/ExpressionOfInterestFilter
 * @version 1.1.3-alpha.1
 */
class ExpressionOfInterestFilter {
  /**
   * Constructs a new <code>ExpressionOfInterestFilter</code>.
   * @alias module:model/ExpressionOfInterestFilter
   */
  constructor() {
    ExpressionOfInterestFilter.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj) {}

  /**
   * Constructs a <code>ExpressionOfInterestFilter</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ExpressionOfInterestFilter} obj Optional instance to populate.
   * @return {module:model/ExpressionOfInterestFilter} The populated <code>ExpressionOfInterestFilter</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ExpressionOfInterestFilter();
      if (data.hasOwnProperty('id')) {
        obj['id'] = _ApiClient.default.convertToType(data['id'], 'String');
      }
      if (data.hasOwnProperty('from')) {
        obj['from'] = _ApiClient.default.convertToType(data['from'], 'String');
      }
      if (data.hasOwnProperty('to')) {
        obj['to'] = _ApiClient.default.convertToType(data['to'], 'String');
      }
      if (data.hasOwnProperty('country_id')) {
        obj['country_id'] = _ApiClient.default.convertToType(data['country_id'], 'String');
      }
      if (data.hasOwnProperty('q')) {
        obj['q'] = _ApiClient.default.convertToType(data['q'], 'String');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>ExpressionOfInterestFilter</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ExpressionOfInterestFilter</code>.
   */
  static validateJSON(data) {
    // ensure the json data is a string
    if (data['id'] && !(typeof data['id'] === 'string' || data['id'] instanceof String)) {
      throw new Error("Expected the field `id` to be a primitive type in the JSON string but got " + data['id']);
    }
    // ensure the json data is a string
    if (data['country_id'] && !(typeof data['country_id'] === 'string' || data['country_id'] instanceof String)) {
      throw new Error("Expected the field `country_id` to be a primitive type in the JSON string but got " + data['country_id']);
    }
    // ensure the json data is a string
    if (data['q'] && !(typeof data['q'] === 'string' || data['q'] instanceof String)) {
      throw new Error("Expected the field `q` to be a primitive type in the JSON string but got " + data['q']);
    }
    return true;
  }
}

/**
 * @member {String} id
 */
ExpressionOfInterestFilter.prototype['id'] = undefined;

/**
 * @member {String} from
 */
ExpressionOfInterestFilter.prototype['from'] = undefined;

/**
 * @member {String} to
 */
ExpressionOfInterestFilter.prototype['to'] = undefined;

/**
 * @member {String} country_id
 */
ExpressionOfInterestFilter.prototype['country_id'] = undefined;

/**
 * @member {String} q
 */
ExpressionOfInterestFilter.prototype['q'] = undefined;
var _default = exports.default = ExpressionOfInterestFilter;